import {
    Button,
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTrigger,
} from '@repo/shadcn';
import { FC, ReactNode, useState } from 'react';

type ConfirmButtonProps = {
    confirmText?: string;
    children?: ReactNode;
    handleConfirm?: () => void | Promise<void>;
    handleConfirmAndPrint?: () => void | Promise<void>;
};

export const ConfirmButton: FC<ConfirmButtonProps> = ({
    confirmText = 'Are you sure you want to perform this action?',
    children,
    handleConfirm = () => {},
    handleConfirmAndPrint,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const onConfirmClick = () => {
        handleConfirm();
        setIsOpen(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>

            <DialogContent>
                <DialogHeader>
                    <h3 className={'text-lg font-bold'}>{confirmText}</h3>
                </DialogHeader>
                <div className={'mt-4 flex justify-end gap-2'}>
                    <Button
                        className={''}
                        type={'button'}
                        variant={'outline'}
                        onClick={() => setIsOpen(false)}
                    >
                        Cancel
                    </Button>
                    <Button type={'button'} onClick={onConfirmClick}>
                        Confirm
                    </Button>
                    {handleConfirmAndPrint && (
                        <Button
                            type={'button'}
                            onClick={() => {
                                handleConfirmAndPrint();
                                setIsOpen(false);
                            }}
                        >
                            Confirm and Print
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

ConfirmButton.displayName = 'ConfirmButton';
